import React, { useContext, useEffect, useState } from "react";
import { MdOutlineCancel } from "react-icons/md";
import { Context } from "../contexts/AuthContext";
import { Button } from ".";
import { userProfileData } from "../data/dummy";
import { useStateContext } from "../contexts/ContextProvider";
import avatar from "../data/avatar.jpg";
import { Avatar, Typography } from "@mui/material";

const UserProfile = () => {
  const { currentColor } = useStateContext();
  const { handleLogout } = useContext(Context);
  const user = localStorage.getItem("user");
  const [userObj, setUserObj] = useState({});

  useEffect(() => {
    if (user) {
      setUserObj(JSON.parse(user));
    }
  }, [user]);

  return (
    <div className="nav-item absolute right-1 top-16 bg-white dark:bg-[#42464D] p-8 rounded-lg w-96">
      <div className="flex justify-between items-center">
        <p className="font-semibold text-lg dark:text-gray-200">Perfil</p>
        <Button
          icon={<MdOutlineCancel />}
          color="rgb(153, 171, 180)"
          bgHoverColor="light-gray"
          size="2xl"
          borderRadius="50%"
        />
      </div>
      <div className="flex gap-5 items-center mt-6 border-color border-b-1 pb-6">
        <Avatar
          alt="user-profile"
          sx={{
            width: 80,
            height: 80,
            border: "1px dashed",
            bgcolor: "primary.main",
          }}
          // src={avatar}
        >
          {<Typography>{userObj?.name?.charAt(0)}</Typography>}
        </Avatar>
        <div>
          <p className="font-semibold text-xl dark:text-gray-200">
            {userObj.name}
          </p>
          <p className="text-gray-500 text-sm dark:text-gray-400">
            Administrador
          </p>
          <p className="text-gray-500 text-sm font-semibold dark:text-gray-400">
            admin@zpcosmeticos.com.br
          </p>
        </div>
      </div>
      {/* <div>
        {userProfileData.map((item, index) => (
          <div
            key={index}
            className="flex gap-5 border-b-1 border-color p-4 hover:bg-light-gray cursor-pointer  dark:hover:bg-[#42464D]"
          >
            <button
              type="button"
              style={{ color: item.iconColor, backgroundColor: item.iconBg }}
              className=" text-xl rounded-lg p-3 hover:bg-light-gray"
            >
              {item.icon}
            </button>

            <div>
              <p className="font-semibold dark:text-gray-200 ">{item.title}</p>
              <p className="text-gray-500 text-sm dark:text-gray-400">
                {item.desc}
              </p>
            </div>
          </div>
        ))}
      </div> */}
      <div className="mt-5">
        <button
          style={{
            backgroundColor: currentColor,
            color: "white",
            borderRadius: "10px",
          }}
          className={`text-sm p-3 w-full hover:drop-shadow-xl hover:bg-${currentColor}`}
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default UserProfile;
